import cn from 'classnames';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import logo from '~assets/mercat-logo-white.svg';
import LinksGroup from '~components/LinksGroup';
import { compareFooterPosition } from '~utils/compare';

import Link from '../Statement/components/Link';

import SocialLink from './components/SocialLink';
import { HOMEPAGE_LINKS, MERCAT_TERMS_AND_CONDITIONS_PAGE, SOCIAL_LINKS } from './constants';
import styles from './styles.module.scss';

const Footer = ({ noCartFooter }) => {
  const cartItems = useSelector((state) => state.cart.cart);
  const { pages } = useSelector((state) => state.pages);
  const { socialNetworks } = useSelector((state) => state.core.settings);
  const cartIsEmpty = !cartItems.length;
  const linkStyle = `text-base text-white ${styles.linkFooter}`;
  const sortedPages = [...(pages?.page ?? [])].sort(compareFooterPosition);
  const allPages = [...sortedPages, MERCAT_TERMS_AND_CONDITIONS_PAGE];

  return (
    <div
      className={cn(styles.footer, 'full-width', {
        [styles.cartFooter]: !noCartFooter && !cartIsEmpty
      })}>
      <footer className={`row middle full-width space-around ${styles.footerContainer}`}>
        <div className={`row m-top-4 m-bottom-4 ${styles.containerGroupLinks}`}>
          <div className={styles.column}>
            {allPages
              .filter((p) => p.published)
              .map((link) => (
                <LinksGroup
                  key={link.title}
                  links={[{ text: link.title, to: link.relativeUrl, style: linkStyle }]}
                />
              ))}
          </div>
        </div>
        <div className={styles.socialLinks}>
          <div className={`row middle ${styles.containerSocialIcons}`}>
            {SOCIAL_LINKS.map(
              ({ id, iClassName }) =>
                socialNetworks[id] && (
                  <SocialLink
                    className="text-white row center middle m-right-2 m-left-2"
                    href={socialNetworks[id]}
                    iClassName={`${iClassName} ${styles.socialIcon}`}
                    key={id}
                  />
                )
            )}
          </div>
        </div>
        <div className={`text-white ${styles.logo}`}>
          <div className={styles.logoContainer}>
            {i18next.t('Footer:poweredBy')}
            <div className={styles.imgContainer}>
              <Link href={HOMEPAGE_LINKS}>
                <img className={styles.applicationLogo} src={logo} alt={i18next.t('App:merkatLogo')} />
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

Footer.propTypes = {
  noCartFooter: PropTypes.bool
};

export default Footer;
